module.exports = __webpack_public_path__ + "img/app@3x.b24e9d63.jpg";